<template>
  <div
    ref="backdrop"
    v-show="open"
    class="product-modal-overlay"
    @click="handleBackdrop"
    aria-hidden="true"
  >
    <div
      ref="dialog"
      class="product-modal-container"
      role="dialog"
      @keydown.esc="handleEsc"
      tabindex="-1"
      aria-modal="true"
      aria-labelledby="product-modal-header"
    >
      <button
        class="product-modal-close"
        @click="toggle"
        aria-label="close dialog"
        style="background-color: inherit"
      >
        <svg
          width="17"
          height="18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1l14 16M1 17L16 1"
            stroke="#4F463F"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <div class="product-modal-text">
        <h1 id="product-modal-header" class="product-modal-header">
          {{ header }}
        </h1>
        <div class="product-modal-body" v-html="body"></div>
      </div>
      <div class="product-modal-image">
        <img :src="image" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { createFocusTrap } from "focus-trap";

export default {
  name: "product-modal",
  data() {
    return {
      modalKey: "product-modal",
      open: false,
      header: null,
      body: null,
      image: null,
      trap: null,
    };
  },
  methods: {
    handleBackdrop(e) {
      const dialog = this.$refs.dialog;
      if (!dialog.contains(e.target)) {
        this.toggle();
      }
    },
    handleEsc(e) {
      e.stopPropagation();
      this.toggle();
    },
    handleOpen(e) {
      // Set product modal props - header, body, image
      const { header, body, image } = e.detail;
      this.header = header;
      this.body = body;
      this.image = image;
      // Toggle modal open
      this.toggle();
    },
    toggle() {
      this.open = !this.open;
    },
  },
  updated() {
    this.$nextTick(function () {
      if (this.open) {
        this.trap.activate();
      } else {
        this.trap.deactivate();
      }
    });
  },
  mounted() {
    window.addEventListener(`${this.modalKey}:open`, this.handleOpen);

    const modal = this.$refs.dialog;
    this.trap = createFocusTrap(modal, { allowOutsideClick: true });
  },
  destroyed() {
    window.removeEventListener(`${this.modalKey}:open`, this.handleOpen);
  },
};
</script>
